import { render } from "./SongResults.vue?vue&type=template&id=8cf0c3ee&scoped=true"
import script from "./SongResults.vue?vue&type=script&lang=js"
export * from "./SongResults.vue?vue&type=script&lang=js"

import "./SongResults.vue?vue&type=style&index=0&id=8cf0c3ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf0c3ee"]])

export default __exports__